import {
    FLOORPLAN_QUERY,
    FLOORPLAN_UPDATE,
    FLOORPLAN_UPDATE_FILTERS,
    FLOORPLAN_UPDATE_ACTIVE,
    FLOORPLAN_UPDATE_ACTIVE_FROM_SLUG,
    FLOORPLAN_UPDATE_FILTER_ACTIVE,
    FLOORPLAN_UPDATE_FILTER_VALUE,
    FLOORPLAN_TOGGLE_FILTER_DROPDOWN,
    FLOORPLAN_FILTER_FLOORPLANS,
    FLOORPLAN_UPDATE_PRODUCT_FILTER_ID,
    FLOORPLAN_UPDATE_PRODUCTS,
    FLOORPLAN_UPDATE_ACTIVE_ELEV,
    FLOORPLAN_ACTIVE_TO_COMPARE,
    FLOORPLAN_COMPARE_TO_ACTIVE,
    FLOORPLAN_UPDATE_ACTIVE_PLAN,
    FLOORPLAN_UPDATE_DISPLAYED_PLAN,
    FLOORPLAN_UPDATE_SEARCH_FILTER_ID,
    FLOORPLAN_FILTER_COMPARE_FLOORPLANS,
    FLOORPLAN_UPDATE_ACTIVE_COMPARE_FLOORPLAN,
    FLOORPLAN_SETUP_COMPARE_FILTERS,
    FLOORPLAN_UPDATE_COMPARE_FILTER_VALUE,
    FLOORPLAN_UPDATE_SITEPLAN_ACTIVE_FLOORPLAN,
    FLOORPLAN_CLEAR_SEARCH_FILTER,
    FLOORPLAN_CLEAR_NORMAL_FILTERS,
    FLOORPLAN_SEND_EMAIL,
    FLOORPLAN_UPDATE_EMAIL_ERROR,
    FLOORPLAN_EMAIL_STATUS,
    FLOORPLAN_CLEAR_COMPARE,
    FLOORPLAN_CLOSE_ALL_FILTER_DROPDOWNS,
    FLOORPLAN_UPDATE_COMPARE_DISPLAYED_PLAN,
    FLOORPLAN_EMAIL_CLEAR_SUBMISSION,
    FLOORPLAN_SETUP_SITEPLAN_LIST,
    FLOORPLAN_CLEAR_COMPARE_HIDDEN,
    FLOORPLAN_UPDATE_ACTIVE_FLOORPLAN,
    FLOORPLAN_UPDATE_ACTIVE_ELEVATION,
    FLOORPLAN_UPDATE_ACTIVE_COMPARE_ELEVATION,
    FLOORPLAN_UPDATE_SEARCH_FILTER_VALUE,
    FLOORPLAN_UPDATE_PRODUCT_FILTER_VALUE,
    FLOORPLAN_UPDATE_SIZE_FILTER_VALUE,
    FLOORPLAN_UPDATE_BEDROOM_FILTER_VALUE,
    FLOORPLAN_UPDATE_COMPARE_PRODUCT_FILTER_VALUE,
    FLOORPLAN_WINDOW_SCROLL_RETURN_POSITION,
    FLOORPLAN_UPDATE_ACTIVE_FLOOR,
    FLOORPLAN_UPDATE_ACTIVE_FLOORPLAN_TO_POPPY,
    FLOORPLAN_UPDATE_ACTIVE_FLOORPLAN_VIA_ID,
    FLOORPLAN_UPDATE_ACTIVE_COMPARE_FLOORPLAN_VIA_ID,
} from "../actions/actionTypes";

function filterUpdateValueByType(value, filter, index) {
    switch (filter.type) {
        case "product":
            filter.index = index;
            return filter.values[value];
        default:
            filter.index = index;
            return value;
    }
}

function filterNumberCmp(a, b) {
    //we need to check both numbers
    var first = parseInt(a.first);
    var second = parseInt(a.second);

    if (!isNaN(second)) {
        if (second < b) return true;
        return false;
    }

    if (first < b) return true;
    return false;
}

function filterMatchCmp(a, b) {
    if (a === b) return false;
    return true;
}

function filterSearchCmp(a, b) {
    a = a.toLowerCase();
    b = b.toLowerCase();

    return !a.includes(b);
}

function floorplanHasUnits(floorplan) {
    var units = false;
    for (var i = 0; i < floorplan.units.length; i++) {
        if (floorplan.units[i].avaliblity && floorplan.units[i].block.active)
            units = true;
    }

    //we need to do a check for the block now
    //we need to see if the

    return units;
}

function findIndexOfFloorplanByEleID(floorplans, ID, ele) {
    for (var i = 0; i < floorplans.length; i++) {
        if (floorplans[i].ID == ID) {
            var eKeys = Object.keys(floorplans[i].elevation);
            var index = eKeys.indexOf(ele);

            if (index === floorplans[i].ele) return i;
        }
    }
    return -1;
}

function findFloorplanBySlug(floorplans, slug) {
    for (var i = 0; i < floorplans.length; i++) {
        const floorplan = floorplans[i];
        const name = floorplan.post_name;

        const eKeys = Object.keys(floorplans[i].elevation);
        for (var j = 0; j < eKeys.length; j++) {
            const ele = eKeys[j];
            const letter = floorplan.elevation[ele].label_elevation.letter_label
                .toLowerCase()
                .replace(new RegExp(" ", "g"), "-");

            const fslug = `${name}-${letter}`;

            //set the ele on the floorplan to this current ele and then return it
            if (fslug === slug) {
                floorplan.ele = j;
                return floorplan;
            }
        }
    }

    //if we didn't find one we should just return ... nothing ? or an empty object or the first one
    //for now ill just do the first one
    return floorplans[0];
}

const initialState = {
    filters: [],
    floorplans: [],
    products: [],
    activeFloorplans: [],
    compareFloorplans: [],
    pnlFloorplanScrollPosition: 0,
    activeFloorplanID: -1,
    activeElevationID: -1,
    activeFloorID: 0,
    productFilterID: -1,
    productFilter: {
        active: false,
        value: "all",
    },
    compareProductFilterID: -1,
    compareProductFilter: {
        active: false,
        value: "all",
    },
    searchFilterID: -1,
    searchFilter: {
        active: false,
        value: "",
    },
    bedroomFilterID: -1,
    bedroomFilter: {
        value: "all",
        active: false,
    },
    sizeFilterID: -1,
    sizeFilter: {
        active: false,
        value: "all",
    },
    activeCompareFloorplans: {
        left: {
            activeFloorplanID: -1,
            activeElevationID: -1,
        },
        right: {
            activeFloorplanID: -1,
            activeElevationID: -1,
        },
    },
    emailError: false,
    emailSubmitted: false,
    emailSubmitting: false,
};

function floorplan(state = initialState, action) {
    switch (action.type) {
        //query
        case FLOORPLAN_QUERY:
            return state;
        case FLOORPLAN_UPDATE:
            var products = [].concat(state.products, action.products);
            var floorplans = [].concat(state.floorplans, action.floorplans);

            return Object.assign({}, state, {
                products: products,
                floorplans: floorplans,
            });
        //code to fix the super annoying scroll thing
        case FLOORPLAN_WINDOW_SCROLL_RETURN_POSITION:
            return Object.assign({}, state, {
                pnlFloorplanScrollPosition: action.scrollPosition,
            });
        //add in code to update active floorplan
        case FLOORPLAN_UPDATE_ACTIVE_FLOORPLAN:
            var newFloorplan = state.floorplans[action.index];
            var currentFloor = state.activeFloorID;

            if (state.activeElevationID != -1) {
                if (newFloorplan.elevation.length > action.index) {
                    if (
                        newFloorplan.elevation[action.index].floorplan_designs
                            .length <= currentFloor
                    ) {
                        currentFloor =
                            currentFloor.elevation[action.index]
                                .floorplan_designs.length - 1;
                    }
                }
            }

            return Object.assign({}, state, {
                activeFloorplanID: action.index,
                activeFloorID: currentFloor,
            });
        case FLOORPLAN_UPDATE_ACTIVE_FLOORPLAN_VIA_ID:
            var ID = action.ID;
            var newActiveIndex = -1;

            for (var i = 0; i < state.floorplans.length; i++) {
                if (state.floorplans[i].ID == ID) {
                    newActiveIndex = i;
                }
            }

            if (newActiveIndex != -1) {
                return Object.assign({}, state, {
                    activeFloorplanID: newActiveIndex,
                    activeFloorID: 0,
                });
            } else return state;
        case FLOORPLAN_UPDATE_ACTIVE_FLOORPLAN_TO_POPPY:
            //find the floorplan
            var poppyIndex = -1;

            for (var i = 0; i < state.floorplans.length; i++) {
                if (state.floorplans[i].ID == 4289) {
                    //this is the index
                    poppyIndex = i;
                }
            }

            if (poppyIndex != -1) {
                return Object.assign({}, state, {
                    activeFloorplanID: poppyIndex,
                    activeElevationID: 0,
                    activeFloorID: 0,
                });
            }
            return state;
        case FLOORPLAN_UPDATE_ACTIVE_ELEVATION:
            //check the next floorplan compared with the current floor to see if it would overflow if so change it down to the maximum range instead
            //so i need the currently active floorplan to check the length of the new elevation
            var currentFloorplan = state.floorplans[state.activeFloorplanID];
            var currentFloor = state.activeFloorID;

            if (action.index != -1) {
                if (
                    currentFloorplan.elevation[action.index].floorplan_designs
                        .length <= currentFloor
                ) {
                    //the activeFloorId also needs to change
                    currentFloor =
                        currentFloorplan.elevation[action.index]
                            .floorplan_designs.length - 1;
                }
            }

            return Object.assign({}, state, {
                activeElevationID: action.index,
                activeFloorID: currentFloor,
            });
        case FLOORPLAN_UPDATE_ACTIVE_FLOOR:
            return Object.assign({}, state, {
                activeFloorID: action.index,
            });
        //compare
        case FLOORPLAN_UPDATE_ACTIVE_COMPARE_FLOORPLAN:
            var compare = Object.assign({}, state.activeCompareFloorplans);
            compare[action.side].activeFloorplanID = action.index;

            return Object.assign({}, state, {
                activeCompareFloorplans: compare,
            });

        case FLOORPLAN_UPDATE_ACTIVE_COMPARE_FLOORPLAN_VIA_ID:
            var ID = action.ID;
            var newActiveIndex = -1;

            //for (var i = 0; i < state.floorplans.length; i++) {
            for (var i = 0; i < state.compareFloorplans.length; i++) {
                //if (state.floorplans[i].ID == ID) {
                if (state.compareFloorplans[i].ID == ID) {
                    newActiveIndex = i;
                }
            }

            if (newActiveIndex != -1) {
                var compare = Object.assign({}, state.activeCompareFloorplans);
                compare[action.side].activeFloorplanID = newActiveIndex;

                return Object.assign({}, state, {
                    activeCompareFloorplans: compare,
                });
            } else return state;
        case FLOORPLAN_UPDATE_ACTIVE_COMPARE_ELEVATION:
            var compare = Object.assign({}, state.activeCompareFloorplans);
            compare[action.side].activeElevationID = action.index;

            return Object.assign({}, state, {
                activeCompareFloorplans: compare,
            });
        case FLOORPLAN_CLEAR_COMPARE:
            var compare = Object.assign({}, state.activeCompareFloorplans);
            compare[action.side].activeElevationID = -1;
            compare[action.side].activeFloorplanID = -1;

            return Object.assign({}, state, {
                activeCompareFloorplans: compare,
            });
        case FLOORPLAN_UPDATE_SITEPLAN_ACTIVE_FLOORPLAN:
            var plans = [].concat(state.siteplanFloorplans);
            var index = findIndexOfFloorplanByEleID(
                plans,
                action.ID,
                action.ele
            );

            var floorplan = plans[index];
            floorplan.bID = action.bID;
            floorplan.unit = action.unit;

            return Object.assign({}, state, {
                activeFloorplan: floorplan,
            });

        case FLOORPLAN_ACTIVE_TO_COMPARE:
            //send the currently active floorplan to the compare
            var activeIndex = state.activeFloorplanID;
            var elevationIndex = state.activeElevationID;

            var activeCompare = Object.assign(
                {},
                state.activeCompareFloorplans
            );

            activeCompare.left.activeFloorplanID = activeIndex;
            activeCompare.left.activeElevationID = elevationIndex;

            return Object.assign({}, state, {
                activeCompareFloorplans: activeCompare,
            });
        case FLOORPLAN_COMPARE_TO_ACTIVE:
            //gotta update some stuff
            var filters = state.filters;
            var productFilterID = state.productFilterID;
            var compareFilters = state.compareFilters;
            var compareFloorplans = state.activeCompareFloorplans;

            var floorplan = {};
            floorplan[action.side] = compareFloorplans[action.side];
            filters[productFilterID].value = compareFilters[action.side];

            return Object.assign({}, state, {
                activeFloorplan: action.floorplan,
                activeCompareFloorplans: {},
                filters: filters,
            });
        case FLOORPLAN_CLEAR_COMPARE_HIDDEN:
            var compare = Object.assign({}, state.compareFloorplans);

            var ss = "left";
            if (action.side === "left") ss = "right";

            //clear all of the hidden fields for this side
            for (var i = 0; i < compare[ss].length; i++) {
                compare[ss][i].compareHide = false;
            }

            return Object.assign({}, state, {
                compareFloorplans: compare,
            });
        case FLOORPLAN_UPDATE_COMPARE_DISPLAYED_PLAN:
            //this needs to get updated in hte normal active floorplan
            //list and it also needs to get updates in the compare floorplan
            //list i hate the way that i set this up now

            var active = Object.assign({}, state.activeCompareFloorplans);
            active[action.side].disp = action.plan;

            var displayPlans = [].concat(state.displayFloorplans);
            var comparePlans = Object.assign({}, state.compareFloorplans);

            //find the floorplan index in all of those lists
            var sKeys = Object.keys(active[action.side].elevation);
            var index = findIndexOfFloorplanByEleID(
                displayPlans,
                active[action.side].ID,
                sKeys[active[action.side].ele]
            );

            if (index !== -1) displayPlans[index].disp = action.plan;

            var keys = Object.keys(comparePlans);
            for (var i = 0; i < keys.length; i++) {
                sKeys = Object.keys(active[action.side].elevation);
                index = findIndexOfFloorplanByEleID(
                    comparePlans[keys[i]],
                    active[action.side].ID,
                    sKeys[active[action.side].ele]
                );

                if (index !== -1)
                    comparePlans[keys[i]][index].disp = action.plan;
            }

            return Object.assign({}, state, {
                activeCompareFloorplans: active,
                displayFloorplans: displayPlans,
                compareFloorplans: comparePlans,
            });
        case FLOORPLAN_UPDATE_DISPLAYED_PLAN:
            var display = [].concat(state.displayFloorplans);
            display[action.floorplanID].disp = action.plan;

            return Object.assign({}, state, {
                displayFloorplans: display,
            });
        case FLOORPLAN_UPDATE_ACTIVE_PLAN:
            var floorplan = Object.assign({}, state.activeFloorplan);
            var display = [].concat(state.displayFloorplans);

            floorplan.disp = action.plan;

            if (typeof display[floorplan.dispID] !== "undefined")
                display[floorplan.dispID].disp = action.plan;

            return Object.assign({}, state, {
                activeFloorplan: floorplan,
                displayFloorplans: display,
            });
        case FLOORPLAN_UPDATE_ACTIVE_ELEV:
            var floorplan = state.activeFloorplan;
            floorplan.ele = action.ele;

            return Object.assign({}, state, {
                activeFloorplan: floorplan,
            });
        case FLOORPLAN_UPDATE_FILTERS:
            //first we need to get the list values
            return Object.assign({}, state, {
                filters: action.newFilters,
            });
        case FLOORPLAN_SETUP_COMPARE_FILTERS:
            var compareFilters = state.compareFilters;
            var filters = state.filters;
            var productFilterID = state.productFilterID;
            compareFilters["left"] = compareFilters["right"] =
                filters[productFilterID].value;

            return Object.assign({}, state, {
                compareFilters: compareFilters,
            });
        case FLOORPLAN_FILTER_FLOORPLANS:
            var fp = [].concat(state.floorplans);

            var floorplans = JSON.parse(JSON.stringify(state.floorplans));

            var searchFilter = state.searchFilter;
            var productFilter = state.productFilter;
            var bedroomFilter = state.bedroomFilter;
            var sizeFilter = state.sizeFilter;
            var activeList = [];

            var hasElv = false;

            for (var i = 0; i < floorplans.length; i++) {
                for (var j = 0; j < floorplans[i].elevation.length; j++) {
                    var add = true;
                    //run through the search filter

                    if (searchFilter.active) {
                        var generatedTitle = floorplans[i].post_title;

                        //we need to only do this if the floorplan only has 1 elevation
                        if (floorplans[i].elevation.length == 1)
                            generatedTitle +=
                                " " + floorplans[i].elevation[j].elevation_name;

                        if (
                            filterSearchCmp(generatedTitle, searchFilter.value)
                        ) {
                            add = false;
                        }
                    }

                    if (!searchFilter.active) {
                        if (productFilter.value != "all") {
                            //now we need to like see if the lot value matches the product value
                            if (
                                productFilter.value !=
                                floorplans[i].type[0].term_id
                            )
                                add = false;
                        }

                        if (bedroomFilter.value != "all") {
                            //now we can just filter by bedrooms not as easy as it sounds
                            //so the string might have a / and it might have space so obviously
                            var filtValue =
                                floorplans[i].elevation[j].stats.bedrooms;
                            var filtValue = filtValue.trim();
                            //now if it has a a / we need to split if it doesn't then we don't
                            if (filtValue.includes("/")) {
                                //we need a split
                                var vals = filtValue.split("/");
                                filtValue = vals;
                            }

                            //now now we either have a number or an array
                            if (Array.isArray(filtValue)) {
                                //check agianst all of the numbers

                                //default add to false so if we beat any of the numbers we can go back to true this is not the same
                                //as all other filter cases
                                var add = false;
                                for (var k = 0; k < filtValue.length; k++) {
                                    if (filtValue[k] >= bedroomFilter.value) {
                                        add = true;
                                    }
                                }
                            } else {
                                if (filtValue < bedroomFilter.value) {
                                    add = false;
                                }
                            }
                        }

                        if (sizeFilter.value != "all") {
                            //lets see what parsing as a number does
                            var sizeFilterNum = parseInt(sizeFilter.value);
                            var elevationNum = parseInt(
                                floorplans[i].elevation[j].stats.size.replace(
                                    /\D/g,
                                    ""
                                )
                            );

                            if (elevationNum < sizeFilterNum) {
                                add = false;
                            }
                        }
                    }

                    if (add) {
                        //floorplans[i].elevation[j].active = true;
                        hasElv = true;
                    } else {
                        //floorplans[i].elevation[j].active = false;
                        floorplans[i].elevation.splice(j, 1);
                        j--;
                    }
                }
                if (floorplans[i].elevation.length == 0) hasElv = false;

                if (hasElv) {
                    activeList.push(floorplans[i]);
                }
            }

            //now force poppy to be first search for it if we find it we'll run some operations
            var poppyIndex = -1;
            for (var i = 0; i < activeList.length; i++) {
                if (activeList[i].ID == 4289) {
                    poppyIndex = i;
                }
            }

            if (poppyIndex != -1) {
                //need to splice out now and add it to the front of the list
                var poppy = activeList.splice(poppyIndex, 1);
                activeList.splice(0, 0, poppy[0]);
            }

            return Object.assign({}, state, {
                floorplan: fp,
                activeFloorplans: activeList,
            });
        case FLOORPLAN_FILTER_COMPARE_FLOORPLANS:
            var fp = [].concat(state.floorplans);

            var floorplans = JSON.parse(JSON.stringify(state.floorplans));

            var productFilter = state.compareProductFilter;
            var activeList = [];

            var hasElv = false;

            for (var i = 0; i < floorplans.length; i++) {
                for (var j = 0; j < floorplans[i].elevation.length; j++) {
                    var add = true;
                    //run through the search filter

                    if (productFilter.value != "all") {
                        //now we need to like see if the lot value matches the product value
                        if (
                            productFilter.value != floorplans[i].type[0].term_id
                        )
                            add = false;
                    }

                    if (add) {
                        //floorplans[i].elevation[j].active = true;
                        hasElv = true;
                    } else {
                        //floorplans[i].elevation[j].active = false;
                        floorplans[i].elevation.splice(j, 1);
                        j--;
                    }
                }

                if (floorplans[i].elevation.length == 0) hasElv = false;

                if (hasElv) {
                    activeList.push(floorplans[i]);
                }
            }

            return Object.assign({}, state, {
                floorplan: fp,
                compareFloorplans: activeList,
            });
        case FLOORPLAN_SETUP_SITEPLAN_LIST:
            var floorplans = state.floorplans;
            var activeList = [];

            for (var i = 0; i < floorplans.length; i++) {
                var eKeys = Object.keys(floorplans[i].elevation);
                for (var k = 0; k < eKeys.length; k++) {
                    var add = true;

                    var floorplan = JSON.parse(JSON.stringify(floorplans[i]));
                    floorplan.realName = floorplan.post_title;
                    floorplan.plan = i;
                    floorplan.disp = 0;
                    floorplan.dispID = activeList.length;
                    floorplan.ele = k;

                    floorplan.post_title += ` ${
                        floorplan.elevation[eKeys[k]].label_elevation
                            .letter_label
                    }`;

                    if (!floorplanHasUnits(floorplan)) add = false;

                    if (add) activeList.push(floorplan);
                }
            }

            /*
            activeList.sort(function(a, b) {
                var aKeys = Object.keys(a.elevation);
                var bKeys = Object.keys(b.elevation);

                return a.elevation[aKeys[a.ele]].info.square_feet -
                    b.elevation[bKeys[b.ele]].info.square_feet
            });
            */

            return Object.assign({}, state, {
                siteplanFloorplans: activeList,
            });
        case FLOORPLAN_UPDATE_FILTER_VALUE:
            var filters = [].concat(state.filters);
            filters[action.id].value = filterUpdateValueByType(
                action.value,
                filters[action.id],
                action.index
            );

            if (filters[action.id].type === "search") {
                if (filters[action.id].value !== "")
                    filters[action.id].active = true;
                else filters[action.id].active = false;
            }

            var compare = Object.assign({}, state.compareFilters);

            if (filters[action.id].type === "product") {
                //update the compare filters
                compare["left"] = filters[action.id].value;
                compare["right"] = filters[action.id].value;
            }

            return Object.assign({}, state, {
                filters: filters,
                compareFilters: compare,
            });
        case FLOORPLAN_UPDATE_PRODUCT_FILTER_VALUE:
            var productFilterID = Object.assign(state.productFilterID);
            productFilterID = action.index;
            var productFilter = Object.assign(state.productFilter);
            productFilter.value = action.value;

            return Object.assign({}, state, {
                productFilterID: productFilterID,
                productFilter: productFilter,
            });
        case FLOORPLAN_UPDATE_COMPARE_PRODUCT_FILTER_VALUE:
            var compareProductFilterID = Object.assign(
                state.compareProductFilterID
            );
            compareProductFilterID = action.index;
            var compareProductFilter = Object.assign(
                state.compareProductFilter
            );
            compareProductFilter.value = action.value;

            return Object.assign({}, state, {
                compareProductFilterID: compareProductFilterID,
                compareProductFilter: compareProductFilter,
            });
        case FLOORPLAN_UPDATE_BEDROOM_FILTER_VALUE:
            var bedroomFilterID = Object.assign(state.bedroomFilterID);
            bedroomFilterID = action.index;
            var bedroomFilter = Object.assign(state.bedroomFilter);
            bedroomFilter.value = action.value;

            return Object.assign({}, state, {
                bedroomFilterID: bedroomFilterID,
                bedroomFilter: bedroomFilter,
            });
        case FLOORPLAN_UPDATE_SIZE_FILTER_VALUE:
            var sizeFilterID = Object.assign(state.sizeFilterID);
            sizeFilterID = action.index;
            var sizeFilter = Object.assign(state.sizeFilter);
            sizeFilter.value = action.value;

            return Object.assign({}, state, {
                sizeFilterID: sizeFilterID,
                sizeFilter: sizeFilter,
            });
        case FLOORPLAN_UPDATE_SEARCH_FILTER_VALUE:
            var searchFilter = Object.assign({}, state.searchFilter);

            searchFilter.value = action.value;

            if (searchFilter.value !== "") searchFilter.active = true;
            else searchFilter.active = false;

            return Object.assign({}, state, {
                searchFilter: searchFilter,
            });
        case FLOORPLAN_TOGGLE_FILTER_DROPDOWN:
            //make the dropdown be open
            var filters = [].concat(state.filters);
            var prod = state.productFilterID;
            var sear = state.searchFilterID;

            filters[action.index].open = action.open;

            for (var i = 0; i < filters.length; i++) {
                if (action.open)
                    if (i !== action.index && i !== prod && i !== sear) {
                        //close this one since it not the one we're opening
                        filters[i].open = false;
                    }
            }

            return Object.assign({}, state, {
                filters: filters,
            });
        case FLOORPLAN_CLOSE_ALL_FILTER_DROPDOWNS:
            var filters = [].concat(state.filters);
            var prod = state.productFilterID;
            var sear = state.searchFilterID;

            for (var i = 0; i < filters.length; i++) {
                if (i !== prod && i !== sear) {
                    filters[i].open = false;
                }
            }

            return Object.assign({}, state, {
                filters: filters,
            });
        case FLOORPLAN_CLEAR_NORMAL_FILTERS:
            //close and clear all of the dropdowns
            var filters = [].concat(state.filters);
            var searchID = state.searchFilterID;
            var productID = state.productFilterID;

            for (var i = 0; i < filters.length; i++) {
                if (i !== searchID && i !== productID) {
                    filters[i].open = false;
                    filters[i].value = -1;
                    filters[i].index = -1;
                }
            }

            return Object.assign({}, state, {
                filters: filters,
            });
        case FLOORPLAN_CLEAR_SEARCH_FILTER:
            //we need to clear out the values from the search filter
            var searchID = state.searchFilterID;
            var filters = [].concat(state.filters);

            //clear the search value and set the active to false
            filters[searchID].value = "";
            filters[searchID].active = false;

            return Object.assign({}, state, {
                filters: filters,
            });
        case FLOORPLAN_UPDATE_COMPARE_FILTER_VALUE:
            var compare = state.compareFilters;
            compare[action.side] = action.term;

            return Object.assign({}, state, {
                compareFilters: compare,
            });
        case FLOORPLAN_UPDATE_FILTER_ACTIVE:
            var filters = state.filters;
            filters[action.id].active = action.active;

            return Object.assign({}, state, {
                filters: filters,
            });
        case FLOORPLAN_UPDATE_PRODUCTS:
            return Object.assign({}, state, {
                products: action.products,
            });
        case FLOORPLAN_UPDATE_PRODUCT_FILTER_ID:
            var filters = state.filters;
            var id = -1;

            filters.map((filter, key) => {
                if (filter.type === "product") id = key;
            });

            return Object.assign({}, state, {
                productFilterID: id,
            });
        case FLOORPLAN_UPDATE_SEARCH_FILTER_ID:
            var filters = state.filters;
            var id = -1;

            filters.map((filter, key) => {
                if (filter.type === "search") id = key;
            });

            return Object.assign({}, state, {
                searchFilterID: id,
            });
        case FLOORPLAN_SEND_EMAIL:
            var submitting = Object.assign({}, state.emailSubmitting);
            submitting = true;
            submitted = false;

            return Object.assign({}, state, {
                emailSubmitting: submitting,
            });
        case FLOORPLAN_EMAIL_STATUS:
            var submitting = Object.assign({}, state.emailSubmitting);
            var submitted = Object.assign({}, state.emailSubmitted);
            var error = Object.assign({}, state.emailError);

            submitting = false;
            if (action.success) submitted = true;
            else error = true;

            return Object.assign({}, state, {
                emailSubmitting: submitting,
                emailSubmitted: submitted,
            });
        case FLOORPLAN_EMAIL_CLEAR_SUBMISSION:
            var submitting = Object.assign({}, state.emailSubmitting);
            var submitted = Object.assign({}, state.emailSubmitted);
            submitted = false;
            submitting = false;

            return Object.assign({}, state, {
                emailSubmitted: submitted,
                emailSubmitting: submitting,
            });
        case FLOORPLAN_UPDATE_EMAIL_ERROR:
            var error = Object.assign({}, state.emailError);

            error = action.err;

            return Object.assign({}, state, {
                emailError: error,
            });
        default:
            return state;
    }
}

export default floorplan;
